import { Spin } from 'antd';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { transformData } from '../gantTransformData';
import useAfterLoader from '../hooks/useAfterLoader';
import { SmxGlobalFilterContext } from '../providers/globalFilterProvider';
import { useSharedUrlParams } from '../routing/useSharedUrlParams';
import { RootState } from '../store';
import {
    CalendarScaleType,
    CalendarViewType,
    ItemTaskType,
    LoaderDataType,
    OnTasksImport,
    ScheduleItemType,
} from '../types';
import Calendar from './calendar';

export interface ICalendarWrapper {
    paddingBottom?: number;
    activePage?: CalendarViewType;
    newTask?: ItemTaskType;
    authorId: string;
    onTasksImport?: OnTasksImport;
}

const CalendarWrapper: React.FC<ICalendarWrapper> = ({
    newTask,
    authorId,
    activePage,
    onTasksImport,
    paddingBottom = 0,
}) => {
    const { filterProject } = useContext(SmxGlobalFilterContext);
    useAfterLoader();
    useSharedUrlParams();

    const scheduleScale = useSelector<RootState, CalendarScaleType>((state) => state.calendar.scheduleScale);
    const dataScheduleItemFromServer = useSelector<RootState, LoaderDataType<ScheduleItemType>>(
        (state) => state.gantLoader.dataScheduleItemFromServer,
    );

    const processedTasksFromServer = useSelector<RootState, ItemTaskType[] | null>(
        (state) => state.calendar.processedTasksFromServer,
    );

    return (
        <Spin
            tip={'Loading...'}
            spinning={
                (!dataScheduleItemFromServer.connectionId || !processedTasksFromServer) &&
                activePage !== 'table' &&
                !!filterProject?.length
            }
        >
            <Calendar
                authorId={authorId}
                inputItems={transformData(dataScheduleItemFromServer.rows)}
                paddingBottom={paddingBottom}
                tasks={processedTasksFromServer ?? []}
                activePage={activePage}
                scheduleScale={scheduleScale}
                newTask={newTask}
                onTasksImport={onTasksImport}
            />
        </Spin>
    );
};

export default CalendarWrapper;
